import React from 'react';
export default function Footer(props) {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className='footer-container center'>
      <div className='row'>
        <button className='btn btn-danger col-2 ' onClick={() => { props.resetQuantity() }}>Reset</button>
        <div className='col-8 bg-dark text-white text-center'>
          <h3>Total Amount: ₹{props.totalAmount}</h3>
        </div>
        <button className='btn btn-primary col-2 ' onClick={handlePrint}>Print</button>
      </div>
    </div>
  );
}
